import React from 'react'
import styled from 'styled-components'

import { useTranslate } from '@hozana/intl/useTranslate'

import { Text } from 'elements/text/Text'
import { Alert, TAlertProps } from 'elements/ui/Alert'

export const StyledText = styled(Text)`
  & > a,
  & > span > a {
    color: ${(props) => props.theme.colors.yellow};
    font-weight: bold;
  }
`

export type TFormErrorProps = TAlertProps

export const FormError: TFCC<TFormErrorProps> = ({ children, ...otherProps }) => {
  const finalChildren = useTranslate(children)

  return (
    React.Children.count(children) > 0 && (
      <Alert status="error" role="alert" {...otherProps} hideCloseButton>
        <StyledText>{finalChildren}</StyledText>
      </Alert>
    )
  )
}
